import React from "react";
import { Box } from "@mui/material";
import { LineChart } from "@mui/x-charts/LineChart";
import moment from "moment-timezone";

/**
 * Conversion Line Chart Component using MUI X Charts
 * Displays conversion data over time
 * @param {Object} props
 * @param {Object} props.data - Line data with name, color, and data array
 * @returns {import("react").ReactElement}
 */
export default function ConversionLine(props) {
  const { data } = props;

  if (!data || !data.data || data.data.length === 0) {
    return <Box sx={{ width: 590, height: 300, display: "inline-block", mb: -2.5 }} />;
  }

  // Extract dates and values from data
  const dates = data.data.map((item) => item.x);
  const values = data.data.map((item) => item.y);

  // Create x-axis data as indices
  const xAxisData = dates.map((_, index) => index);

  // Format dates for x-axis labels
  const formattedDates = dates.map((date) => moment.utc(date).format("MMM DD"));

  return (
    <Box sx={{ position: "relative" }}>
      <Box sx={{ display: "inline-block", width: 590, height: 300, mb: -2.5 }}>
        <LineChart
          xAxis={[
            {
              data: xAxisData,
              scaleType: "point",
              valueFormatter: (value) => formattedDates[value] || "",
              tickLabelStyle: {
                fontSize: 11,
              },
            },
          ]}
          yAxis={[
            {
              disableLine: true,
            },
          ]}
          series={[
            {
              data: values,
              label: data.name || "Value",
              color: data.color || "#03a9f4",
              showMark: false,
              curve: "linear",
              valueFormatter: (value) => {
                if (typeof value === "number") {
                  // Format as currency if it looks like revenue data
                  if (data.name?.toLowerCase().includes("revenue")) {
                    return `$${value.toLocaleString()}`;
                  }
                  return value.toLocaleString();
                }
                return String(value);
              },
            },
          ]}
          width={590}
          height={300}
          margin={{ top: 20, right: 20, bottom: 30, left: 50 }}
          hideLegend
        />
      </Box>
    </Box>
  );
}
